import React from "react";
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from "react-intl";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// path constants
import * as paths from '@app/constants/paths';
import * as plans from '@app/constants/plans';
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Card from "@app/components/Card/Card";
import CardBody from "@app/components/Card/CardBody";
import CardFooter from "@app/components/Card/CardFooter";
import Button from "@app/components/CustomButtons/Button";
import NavPills from "@app/components/NavPills/NavPills";

import HttpsIcon from '@material-ui/icons/Https';
import WebIcon from '@material-ui/icons/Web';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import LanguageIcon from '@material-ui/icons/Language';
import LanguageTwoToneIcon from '@material-ui/icons/LanguageTwoTone';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import ShareIcon from '@material-ui/icons/Share';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import SchoolIcon from '@material-ui/icons/School';
import GroupIcon from '@material-ui/icons/Group';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import BusinessIcon from '@material-ui/icons/Business';
import SearchIcon from '@material-ui/icons/Search';
import ReceiptIcon from '@material-ui/icons/Receipt';
import PaymentIcon from '@material-ui/icons/Payment';

import pricingStyle from "@app/assets/jss/material-kit-pro-react/views/sectionsSections/pricingStyle";

function SectionPricing(props) {
    const { classes } = props;

    const verifyAccount = props.intl.formatMessage({ id: "verify.account.with.email" });
    const addSocialAccount = props.intl.formatMessage({ id: "add.social.account.to.leave.reviews" });
    const freeTrial = props.intl.formatMessage({ id: "30.day.free.trial" });
    const availAddOns = props.intl.formatMessage({ id: "avail.add.ons" });
    const online = props.intl.formatMessage({ id: "online" });
    const shortWebAddress = props.intl.formatMessage({ id: "short.web.address" });
    const landingPage = props.intl.formatMessage({ id: "landing.page" });
    const call2ActionSocialMedia = props.intl.formatMessage({ id: "call.to.action.latest.social.media" });
    const contactDetailsPage = props.intl.formatMessage({ id: "contact.details.page" });
    const mapAndMessages = props.intl.formatMessage({ id: "maps.and.messages" });
    const tenPerMonth = props.intl.formatMessage({ id: "10.per.month" });
    const business = props.intl.formatMessage({ id: "business" });
    const everythingFrom = props.intl.formatMessage({ id: "everything.from" });
    const customWebAddress = props.intl.formatMessage({ id: "custom.web.address" });
    const yourBizName = props.intl.formatMessage({ id: "your.biz.name" });
    const apptSched = props.intl.formatMessage({ id: "appointment.scheduling" });
    const letBookOnline = props.intl.formatMessage({ id: "let.customers.book.online" });
    const servicesPage = props.intl.formatMessage({ id: "services.page" });
    const targetJobs = props.intl.formatMessage({ id: "target.specific.jobs" });
    const accreditationsIndemnities = props.intl.formatMessage({ id: "accreditations.and.indemnities" });
    const showCompetenciesCoverage = props.intl.formatMessage({ id: "show.your.competencies.coverage" });
    const teamProfilePages = props.intl.formatMessage({ id: "team.profile.pages" });
    const showOffCrew = props.intl.formatMessage({ id: "show.off.your.crew" });
    const gallery = props.intl.formatMessage({ id: "gallery" });
    const showYourWork = props.intl.formatMessage({ id: "show.off.your.work" });
    const twoHundredPerMonth = props.intl.formatMessage({ id: "200.per.month" });
    const enterprise = props.intl.formatMessage({ id: "enterprise" });
    const googleBiz = props.intl.formatMessage({ id: "google.biz.listing" });
    const showUpGoogle = props.intl.formatMessage({ id: "show.up.google.search" });
    const keywords = props.intl.formatMessage({ id: "keywords" });
    const seo = props.intl.formatMessage({ id: "seo" });
    const boostSEO = props.intl.formatMessage({ id: "boost.search.engine.ranking" });
    const invoicing = props.intl.formatMessage({ id: "invoicing" });
    const savesTimePaidFaster = props.intl.formatMessage({ id: "saves.time.paid.faster" });
    const payments = props.intl.formatMessage({ id: "payments" });
    const creditCardCharge = props.intl.formatMessage({ id: "credit.card.charge" });
    const oneKPerMonth = props.intl.formatMessage({ id: "one.thousand.per.month" });
    const domain = props.intl.formatMessage({ id: "domain" });
    const packageHosted = props.intl.formatMessage({ id: "package.hosted.own.domain" });
    const leads = props.intl.formatMessage({ id: "leads" });
    const browseRequests = props.intl.formatMessage({ id: "browse.requests.customers" });
    const social = props.intl.formatMessage({ id: "social" });
    const aiSocial = props.intl.formatMessage({ id: "ai.social.personas" });
    const ads = props.intl.formatMessage({ id: "ads" });
    const yearly = props.intl.formatMessage({ id: "yearly" });
    const monthly = props.intl.formatMessage({ id: "monthly" });

    const headerCus = (
        <GridContainer>
            <GridItem
                xs={12}
                sm={12}
                md={8}
                className={classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter}
            >
                <h2 className={classes.description}>
                    {verifyAccount}
                </h2>
                <h3 className={classes.description}>
                    {addSocialAccount}
                </h3>
            </GridItem>
        </GridContainer>
    );

    const headerPro = (
        <GridContainer>
            <GridItem
                xs={12}
                sm={12}
                md={8}
                className={classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter}
            >
                <h2 className={classes.title}>
                    {freeTrial}
                </h2>
            </GridItem>
        </GridContainer>
    );

    const addOnsHeader = (
        <GridContainer>
            <GridItem
                xs={12}
                sm={12}
                md={8}
                className={classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter}
            >
                <h2 className={classes.title}>
                    {availAddOns}
                </h2>
            </GridItem>
        </GridContainer>
    );

    const header = props.free ? headerCus : headerPro;

    const onlineM = (
        <GridItem xs={12} sm={12} md={4} lg={4}>
            <Card raised>
                <CardBody textCenter>
                    <h3 className={classes.cardCategory + " " + classes.textCenter}>{online.toUpperCase()}</h3>
                    <h4 className={classes.cardTitleBig + " " + classes.textCenter}>
                        <small>€</small> 0
          </h4>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <LanguageIcon />&nbsp;{shortWebAddress}
                    </h5>
                    <p>localpro.ie/@abc123</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <WebIcon />&nbsp;{landingPage}
                    </h5>
                    <p>{call2ActionSocialMedia}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ContactMailIcon />&nbsp;{contactDetailsPage}</h5>
                    <p>{mapAndMessages} ({tenPerMonth})</p>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                    <Button
                        color="danger"
                        size="lg"
                        to={props.member ? paths.SIGN_UP_PLAN + plans.ONLINE_M :
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.ONLINE_M)}
                        component={Link}
                        aria-label={props.intl.formatMessage({ id: "try.for.free" })}>
                        <b><FormattedMessage id="try.for.free" /></b>
                    </Button>
                </CardFooter>
            </Card>
        </GridItem>
    );
    const businessM = (
        <GridItem xs={12} sm={12} md={4} lg={4}>
            <Card raised>
                <CardBody textCenter>
                    <h3 className={classes.cardCategory + " " + classes.textCenter}>{business.toUpperCase()}</h3>
                    <h4 className={classes.cardTitleBig + " " + classes.textCenter}>
                        <small>€</small> 20
          </h4>
                    <p><i>{everythingFrom}&nbsp;<b>{online.toUpperCase()}</b></i></p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <LanguageTwoToneIcon />&nbsp;{customWebAddress}
                    </h5>
                    <p>localpro.ie/@{yourBizName}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ScheduleIcon />&nbsp;{apptSched}
                    </h5>
                    <p>{letBookOnline}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <SettingsApplicationsIcon />&nbsp;{servicesPage}
                    </h5>
                    <p>{targetJobs}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <SchoolIcon />&nbsp;{accreditationsIndemnities}
                    </h5>
                    <p>{showCompetenciesCoverage}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <GroupIcon />&nbsp;{teamProfilePages} (20)
          </h5>
                    <p>{showOffCrew}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <PhotoLibraryIcon />&nbsp;{gallery} (200)
          </h5>
                    <p>{showYourWork}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ContactMailIcon />&nbsp;{contactDetailsPage}
                    </h5>
                    <p>{mapAndMessages} ({twoHundredPerMonth})</p>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                    <Button
                        color="danger"
                        size="lg"
                        to={props.member ? paths.SIGN_UP_PLAN + plans.BUSINESS_M :
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.BUSINESS_M)}
                        component={Link}
                        aria-label={props.intl.formatMessage({ id: "try.for.free" })}>
                        <b><FormattedMessage id="try.for.free" /></b>
                    </Button>
                </CardFooter>
            </Card>
        </GridItem>
    );

    const enterpriseM = (
        <GridItem xs={12} sm={12} md={4} lg={4}>
            <Card raised>
                <CardBody textCenter>
                    <h3 className={classes.cardCategory + " " + classes.textCenter}>{enterprise.toUpperCase()}</h3>
                    <h4 className={classes.cardTitleBig + " " + classes.textCenter}>
                        <small>€</small> 100
          </h4>
                    <p><i>{everythingFrom}&nbsp;<b>{online.toUpperCase()}</b> & <b>{business.toUpperCase()}</b></i></p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <BusinessIcon />&nbsp;{googleBiz}
                    </h5>
                    <p>{showUpGoogle}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <SearchIcon />&nbsp;{seo}</h5>
                    <p>{boostSEO}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ReceiptIcon />&nbsp;{invoicing}
                    </h5>
                    <p>{savesTimePaidFaster}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <PaymentIcon />&nbsp;{payments}</h5>
                    <p>{creditCardCharge}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <GroupIcon />&nbsp;{teamProfilePages} (100)
          </h5>
                    <p>{showOffCrew}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <PhotoLibraryIcon />&nbsp;{gallery} (1,000)
          </h5>
                    <p>{showYourWork}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ContactMailIcon />&nbsp;{contactDetailsPage}
                    </h5>
                    <p>{mapAndMessages} ({oneKPerMonth})</p>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                    <Button
                        color="danger"
                        size="lg"
                        to={props.member ? paths.SIGN_UP_PLAN + plans.ENTERPRISE_M :
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.ENTERPRISE_M)}
                        component={Link}
                        aria-label={props.intl.formatMessage({ id: "try.for.free" })}>
                        <b><FormattedMessage id="try.for.free" /></b>
                    </Button>
                </CardFooter>
            </Card>
        </GridItem>
    );

    const addOnsM = (
        <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
                <Card raised>
                    <CardBody textCenter>
                        <HttpsIcon />
                        <h3 className={classes.cardTitle + " " + classes.textCenter}>{domain.toUpperCase()}</h3>
                        <h4 className={classes.cardTitle + " " + classes.textCenter}>
                            + €10
            </h4>
                        <h5 className={classes.cardTitle + " " + classes.textCenter}>{packageHosted}</h5>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
                <Card raised>
                    <CardBody textCenter>
                        <GroupAddIcon />
                        <h3 className={classes.cardTitle + " " + classes.textCenter}>{leads.toUpperCase()}</h3>
                        <h4 className={classes.cardTitle + " " + classes.textCenter}>
                            €10+
            </h4>
                        <h5 className={classes.cardTitle + " " + classes.textCenter}>{browseRequests}</h5>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
                <Card raised>
                    <CardBody textCenter>
                        <ShareIcon />
                        <h3 className={classes.cardTitle + " " + classes.textCenter}>{social.toUpperCase()}</h3>
                        <h4 className={classes.cardTitle + " " + classes.textCenter}>
                            €25+
            </h4>
                        <h5 className={classes.cardTitle + " " + classes.textCenter}>{aiSocial}</h5>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
                <Card raised>
                    <CardBody textCenter>
                        <ShoppingCartIcon />
                        <h3 className={classes.cardTitle + " " + classes.textCenter}>{ads.toUpperCase()}</h3>
                        <h4 className={classes.cardTitle + " " + classes.textCenter}>
                            €50+
            </h4>
                        <h5 className={classes.cardTitle + " " + classes.textCenter}>Google, Facebook, Reddit, LinkedIn, Twitter, Pinterest...</h5>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );

    const onlineY = (
        <GridItem xs={12} sm={12} md={4} lg={4}>
            <Card raised>
                <CardBody textCenter>
                    <h3 className={classes.cardCategory + " " + classes.textCenter}>{online.toUpperCase()}</h3>
                    <h4 className={classes.cardTitleBig + " " + classes.textCenter}>
                        <small>€</small> 0
          </h4>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <LanguageIcon />&nbsp;{shortWebAddress}
                    </h5>
                    <p>localpro.ie/@abc123</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <WebIcon />&nbsp;{landingPage}
                    </h5>
                    <p>{call2ActionSocialMedia}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ContactMailIcon />&nbsp;{contactDetailsPage}
                    </h5>
                    <p>{mapAndMessages} ({tenPerMonth})</p>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                    <Button
                        color="danger"
                        size="lg"
                        to={props.member ? paths.SIGN_UP_PLAN + plans.ONLINE_Y :
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.ONLINE_Y)}
                        component={Link}
                        aria-label={props.intl.formatMessage({ id: "try.for.free" })}>
                        <b><FormattedMessage id="try.for.free" /></b>
                    </Button>
                </CardFooter>
            </Card>
        </GridItem>
    );

    const businessY = (
        <GridItem xs={12} sm={12} md={4} lg={4}>
            <Card raised>
                <CardBody textCenter>
                    <h3 className={classes.cardCategory + " " + classes.textCenter}>{business.toUpperCase()}</h3>
                    <h4 className={classes.cardTitleBig + " " + classes.textCenter}>
                        <small>€</small> 200
          </h4>
                    <p><i>{everythingFrom}&nbsp;<b>{online.toUpperCase()}</b></i></p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <LanguageTwoToneIcon />&nbsp;{customWebAddress}
                    </h5>
                    <p>localpro.ie/@{yourBizName}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ScheduleIcon />&nbsp;{apptSched}
                    </h5>
                    <p>{letBookOnline}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <SettingsApplicationsIcon />&nbsp;{servicesPage}
                    </h5>
                    <p>{targetJobs}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <SchoolIcon />&nbsp;{accreditationsIndemnities}
                    </h5>
                    <p>{showCompetenciesCoverage}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <GroupIcon />&nbsp;{teamProfilePages} (20)
          </h5>
                    <p>{showOffCrew}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <PhotoLibraryIcon />&nbsp;{gallery} (200)
          </h5>
                    <p>{showYourWork}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ContactMailIcon />&nbsp;{contactDetailsPage}
                    </h5>
                    <p>{mapAndMessages} ({twoHundredPerMonth})</p>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                    <Button
                        color="danger"
                        size="lg"
                        to={props.member ? paths.SIGN_UP_PLAN + plans.BUSINESS_Y :
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.BUSINESS_Y)}
                        component={Link}
                        aria-label={props.intl.formatMessage({ id: "try.for.free" })}>
                        <b><FormattedMessage id="try.for.free" /></b>
                    </Button>
                </CardFooter>
            </Card>
        </GridItem>
    );

    const enterpriseY = (
        <GridItem xs={12} sm={12} md={4} lg={4}>
            <Card raised>
                <CardBody textCenter>
                    <h3 className={classes.cardCategory + " " + classes.textCenter}>{enterprise.toUpperCase()}</h3>
                    <h4 className={classes.cardTitleBig + " " + classes.textCenter}>
                        <small>€</small> 1,000
          </h4>
                    <p><i>{everythingFrom}&nbsp;<b>{online.toUpperCase()}</b> & <b>{business.toUpperCase()}</b></i></p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <BusinessIcon />&nbsp;{googleBiz}
                    </h5>
                    <p>{showUpGoogle}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <SearchIcon />&nbsp;{seo}
                    </h5>
                    <p>{boostSEO}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ReceiptIcon />&nbsp;{invoicing}
                    </h5>
                    <p>{savesTimePaidFaster}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <PaymentIcon />&nbsp;{payments}
                    </h5>
                    <p>{creditCardCharge}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <GroupIcon />&nbsp;{teamProfilePages} (100)</h5>
                    <p>{showOffCrew}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <PhotoLibraryIcon />&nbsp;{gallery} (1,000)</h5>
                    <p>{showYourWork}</p>
                    <h5 className={classes.cardTitle + " " + classes.textCenter}>
                        <ContactMailIcon />&nbsp;{contactDetailsPage}</h5>
                    <p>{mapAndMessages} ({oneKPerMonth})</p>
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                    <Button
                        color="danger"
                        size="lg"
                        to={props.member ? paths.SIGN_UP_PLAN + plans.ENTERPRISE_Y :
                            paths.SIGN_UP_PROFESSIONAL + '?continue=' + encodeURIComponent(paths.SIGN_UP_PLAN + plans.ENTERPRISE_Y)}
                        component={Link}
                        aria-label={props.intl.formatMessage({ id: "try.for.free" })}>
                        <b><FormattedMessage id="try.for.free" /></b>
                    </Button>
                </CardFooter>
            </Card>
        </GridItem>
    );

    const addOnsY = (
        <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
                <Card raised>
                    <CardBody textCenter>
                        <HttpsIcon />
                        <h3 className={classes.cardTitle + " " + classes.textCenter}>{domain.toUpperCase()}</h3>
                        <h4 className={classes.cardTitle + " " + classes.textCenter}>
                            + €100
            </h4>
                        <h5 className={classes.cardTitle + " " + classes.textCenter}>{packageHosted}</h5>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
                <Card raised>
                    <CardBody textCenter>
                        <GroupAddIcon />
                        <h3 className={classes.cardTitle + " " + classes.textCenter}>{leads.toUpperCase()}</h3>
                        <h4 className={classes.cardTitle + " " + classes.textCenter}>
                            €100+
            </h4>
                        <h5 className={classes.cardTitle + " " + classes.textCenter}>{browseRequests}</h5>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
                <Card raised>
                    <CardBody textCenter>
                        <ShareIcon />
                        <h3 className={classes.cardTitle + " " + classes.textCenter}>{social.toUpperCase()}</h3>
                        <h4 className={classes.cardTitle + " " + classes.textCenter}>
                            €250+
            </h4>
                        <h5 className={classes.cardTitle + " " + classes.textCenter}>{aiSocial}</h5>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
                <Card raised>
                    <CardBody textCenter>
                        <ShoppingCartIcon />
                        <h3 className={classes.cardTitle + " " + classes.textCenter}>{ads.toUpperCase()}</h3>
                        <h4 className={classes.cardTitle + " " + classes.textCenter}>
                            €500+
            </h4>
                        <h5 className={classes.cardTitle + " " + classes.textCenter}>Google, Facebook, Reddit, LinkedIn, Twitter, Pinterest...</h5>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );

    return (
        <div className={classes.pricing + " " + classes.sectionWhite}>
            <div className={classes.container}>
                {header}
                {!props.free && <GridContainer>
                    <GridItem
                        xs={12}
                        className={classes.mlAuto + " " + classes.mrAuto}
                    >
                        <NavPills
                            active={1}
                            alignCenter
                            color="danger"
                            tabs={[
                                {
                                    tabButton: monthly,
                                    tabContent: (
                                        <div>
                                            <GridContainer>
                                                {onlineM}
                                                {businessM}
                                                {enterpriseM}
                                            </GridContainer>
                                            {addOnsHeader}
                                            {addOnsM}
                                        </div>
                                    )
                                },
                                {
                                    tabButton: yearly,
                                    tabContent: (
                                        <div>
                                            <GridContainer>
                                                {onlineY}
                                                {businessY}
                                                {enterpriseY}
                                            </GridContainer>
                                            {addOnsHeader}
                                            {addOnsY}
                                        </div>
                                    )
                                }
                            ]}
                        />
                    </GridItem>
                </GridContainer>}
            </div>
        </div>
    );
}

export default injectIntl(withStyles(pricingStyle)(SectionPricing));
